export default __webpack_public_path__ + "static/media/selection.0b00798b.svg";